import angular from 'angular';

(function () {
    'use strict';
    var core = angular.module('app.admin.audit');

    core.constant(
        'AUDIT',
        Object.freeze({
            audits: {
                pagination: {
                    defaultPageSize: 100,
                    defaultSort: [
                        {
                            direction: 'DESC',
                            property: 'date',
                        },
                    ],
                    defaultPage: 0,
                },
                columnFieldMap: [
                    {
                        field: 'date',
                        property: 'creationDate',
                    },
                    {
                        field: 'userId',
                        property: 'authorId',
                    },
                ],
            },
        })
    );
})();
